import React from 'react';

export const siteContent = {
  personal: {
    name: "Daniel Polatajko",
    tagline: "Software Engineer at the U.K. AI Security Institute"
  },
  about: {
    title: "About",
    paragraphs: [
      <>I'm currently a Software Engineer at the <a href="https://www.aisi.gov.uk/" className="link">U.K. AI Security Institute</a>, building research tooling for AISI's frontier model evaluation work. Previously, I spent 5 years as a generalist engineer in climate tech, and build demonstrations of AI scheming and  loss-of-control risks at <a href="https://www.apolloresearch.ai/" className="link">Apollo Research</a>. I care about solving problems that have widespread and unequitable impacts on humanity, and believe that technology is a great way to do this.</>,
      <>Outside of tech, I like <a href="https://www.walkhighlands.co.uk/Forum/munros.php?u=198319" className="link">climbing mountains</a>, losing pub quizzes, and playing guitar in a folk-rock band called <a href="https://www.instagram.com/steeplekeeperband/" className="link">Steeplekeeper</a>.</>
    ]
  },
  projects: {
    title: "Projects",
    items: [
      {
        title: "Inspect WandB",
        description: "An open-source integration between Inspect and Weights & Biases.",
        links: [
          {
            url: "https://github.com/DanielPolatajko/inspect_wandb",
            icon: "github",
            text: "GitHub"
          },
          {
            url: "https://inspect-wandb.readthedocs.io/en/latest/index.html",
            icon: "website",
            text: "Documentation site"
          }
        ]
      },
      {
        title: "Using Inspect for AI Safety Research",
        description: "A workshop talk I presented at the UK AI Forum's AI & Societal Robustness Conference",
        links: [
          {
            url: "https://github.com/DanielPolatajko/ukaiforum_inspect_workshop",
            icon: "github",
            text: "GitHub"
          },
          {
            url: "https://ukaiforum.substack.com/p/building-resilience-in-the-age-of#:~:text=Daniel%20Polatajko%20%2D%20Workshop%3A%20using%20Inspect%20for%20AIS%20Research",
            icon: "website",
            text: "Organiser's blog post"
          }
        ]
      },
      {
        title: "eval-crypt", 
        description: "An encryption/decryption Git hook, designed for encrypting sensitive evals code in Python projects.",
        links: [
          {
            url: "https://github.com/DanielPolatajko/eval-crypt",
            icon: "github", 
            text: "GitHub"
          }
        ]
      },
      {
        title: "Personal RAG Context",
        description: "A simple RAG application that stores things I've read online, and helps me to quickly remember details later.",
        links: [
          {
            url: "https://github.com/DanielPolatajko/personal-rag",
            icon: "github",
            text: "GitHub"
          }
        ]
      }
    ]
  },
  contact: {
    title: "Connect",
    links: [
      {
        text: "Email",
        url: "mailto:danielpolatajko@gmail.com"
      },
      {
        text: "GitHub",
        url: "https://github.com/DanielPolatajko"
      },
      {
        text: "LinkedIn", 
        url: "https://www.linkedin.com/in/daniel-polatajko/"
      }
    ]
  }
};
